module.exports = __webpack_public_path__ + "static/media/hamburger-menu.be2ee05a.svg";